var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3301_1895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58169 0 0 3.58166 0 8C0 12.4183 3.58169 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58166 12.4183 0 8 0ZM12.0091 8.10612L8.19681 11.7331C7.82838 12.0839 7.24572 12.0696 6.89516 11.7009C6.54459 11.3324 6.55922 10.7492 6.92741 10.3992L8.48134 8.92091H4.80016C4.29134 8.92091 3.87931 8.50884 3.87931 8.00003C3.87931 7.49122 4.29137 7.07941 4.80016 7.07941H8.48137L6.92744 5.60084C6.55925 5.25106 6.54462 4.66762 6.89519 4.29947C7.24575 3.93078 7.82841 3.91612 8.19684 4.26722L12.0091 7.89391C12.0381 7.92162 12.0544 7.95994 12.0544 8C12.0544 8.04006 12.0381 8.07837 12.0091 8.10612Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3301_1895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightCircle);
export default __webpack_public_path__ + "static/media/icon_arrow_right_circle.fdd41b9aa395d10122472a123cc5af1e.svg";
export { ForwardRef as ReactComponent };